var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6874 17.9017C10.7015 17.3758 10.7015 15.9627 11.6874 15.4369L24.3452 8.68646C24.756 8.46738 25.2489 8.46739 25.6597 8.68649L38.316 15.4369C39.3019 15.9627 39.3019 17.3758 38.316 17.9016L25.6597 24.652C25.2489 24.8711 24.756 24.8712 24.3452 24.6521L11.6874 17.9017ZM10.0801 33.7378C9.64414 33.4893 9.375 33.0261 9.375 32.5244V21.1563C9.375 20.0846 10.5322 19.4122 11.4633 19.9429L23.2617 26.6678C23.6976 26.9163 23.9668 27.3795 23.9668 27.8812V39.2493C23.9668 40.321 22.8095 40.9934 21.8784 40.4627L10.0801 33.7378ZM38.5369 19.9438C39.468 19.4127 40.6255 20.0851 40.6255 21.157V32.5246C40.6255 33.0263 40.3565 33.4894 39.9208 33.7379L28.1308 40.4618C27.1997 40.9929 26.0422 40.3205 26.0422 39.2486V27.881C26.0422 27.3793 26.3112 26.9162 26.7469 26.6677L38.5369 19.9438Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/Cube.cfae55f461e51a61a09b211b9582f7bc.svg";
export { ForwardRef as ReactComponent };